export default class GoogleAnalyticsQuery {

    public static GetGoogleAnalyticsUserSessions = `query GetGoogleAnalyticsUserSessionsQuery($input: ReportInput!) {
            getGoogleAnalyticsUserSessions(input: $input) {
                date
                users
                newUsers
                sessions
                bounces
                bounceRate
                sessionDuration
                avgSessionDuration
            }     
        }`;

    public static GetGoogleAnalyticsTrafficSources = `query GetGoogleAnalyticsTrafficSourcesQuery($input: ReportInput!) {
            getGoogleAnalyticsTrafficSources(input: $input) {
                date
                source
                medium
                visits
            }     
        }`;

    public static GetGoogleAnalyticsPageViews = `query GetGoogleAnalyticsPageViewsQuery($input: ReportInput!) {
            getGoogleAnalyticsPageViews(input: $input) {
                date
                pagePath
                pageviews
                uniquePageviews
                avgTimeOnPage
            }     
        }`;
}